import { useId } from '@reach/auto-id';
import React from 'react';
import { useIconGenerator } from '../hooks/use-icon-generator';


const RelicIcon: React.FC<{ name: string, className?: string }> = ({ name, className }) => {  
  const [iconData] = useIconGenerator(name);
  const id = useId();

  return <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" height="256" width="256">
    <defs>
      <linearGradient id={`Gradient_${id}`} gradientTransform="rotate(270)" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={'#' + iconData.backgroundColor} />
        <stop offset="100%" stopColor="white" />
      </linearGradient>
    </defs>
    <circle cx="128" cy="128" r="128" fill={`url(#Gradient_${id})`} />
    <circle cx="128" cy="128" r="125" fill="transparent" stroke={iconData.foregroundColor} strokeWidth="6px" />
    <text textAnchor="middle" x="50%" y="50%" dy="0.35em" fill={iconData.foregroundColor}
      fontSize={iconData.fontSize} fontFamily={iconData.fontFamily}>
      {iconData.characters}
    </text>
  </svg>
}

export default RelicIcon;
